import { GET_PERMISSIONS } from './action';

import { Roles, getKeyByValue } from '../constant';

const initialState = {
    currentUser: {
        name: '',
        email: '',
        roles: [],
        permissions: []
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case 'AAD_LOGIN_SUCCESS': {
            return {
                ...state,
                currentUser: {
                    name: action.payload.account.name,
                    email: action.payload.account.userName,
                    roles: [],
                    permissions: []
                }
            }
        }
        case GET_PERMISSIONS: {            
            const roles = action.payload.roles.map(r => getKeyByValue(Roles, r.role))
            const permissions = action.payload.roles.flatMap(r =>
                r.permission.map(p => {
                    const roleKey = getKeyByValue(Roles, r.role);
                    const permissionKey = getKeyByValue(Roles[roleKey].permissions, p);

                    return permissionKey;
                })
            );

            return {
                ...state,
                currentUser: {
                    ...state.currentUser,
                    roles: roles,
                    permissions: permissions
                }
            }
        }
        default:
            return state;
    }
}